import { Code, Tab, TabList, TabPanel, TabPanels, Tabs } from '@apollo/orbit';
import React from 'react';

export interface CodeFile {
  content: string;
  tabLabel?: string;
}

interface CodeTabBlockProps {
  tabs: CodeFile[];
  onCodeClick?: (content: string, tabLabel: string) => void;
}

const CodeBlockHeader = ({ tabs }: { tabs: CodeFile[] }) => {
  return (
    <TabList>
      {tabs.map((tab, index) => {
        const label = tab.tabLabel || `Tab ${index + 1}`; // Use tabLabel if provided, otherwise fallback to tab index
        const uniqueKey = `${label}-${tab.content.substring(0, 10).replace(/\s+/g, '')}`;
        return <Tab key={uniqueKey}>{label}</Tab>;
      })}
    </TabList>
  );
};

interface CodeBodyProps {
  content: string;
  tabLabel: string;
  onCodeClick?: (content: string, tabLabel: string) => void;
}

const CodeBody = ({ content, tabLabel, onCodeClick }: CodeBodyProps) => {
  return (
    <div className="mt-4 w-full">
      <Code
        canCopy
        onClick={() => {
          if (onCodeClick) {
            onCodeClick(content, tabLabel);
          }
        }}
        className="h-12 w-full justify-between p-3"
      >
        {content}
      </Code>
    </div>
  );
};

export const CodeTabBlock = ({ tabs, onCodeClick }: CodeTabBlockProps) => {
  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <Tabs>
      <CodeBlockHeader tabs={tabs} />
      <TabPanels>
        {tabs.map((tab, index) => {
          const label = tab.tabLabel || `Tab ${index + 1}`;
          const uniqueKey = `panel-${label}-${tab.content.substring(0, 10).replace(/\s+/g, '')}`;
          return (
            <TabPanel key={uniqueKey}>
              <CodeBody
                content={tab.content}
                tabLabel={label}
                onCodeClick={onCodeClick}
              />
            </TabPanel>
          );
        })}
      </TabPanels>
    </Tabs>
  );
};
